import { LoginForm } from "@/features/login";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../httpClient";
import { getSession } from "../../requests/getSession";

export const Route = createFileRoute("/(auth)/")({
  component: LoginForm,
  head: () => ({
    meta: [{ title: "Login - Backoffice Detentora Iniciador" }],
  }),
  beforeLoad: async () => {
    const { error } = await getSession();

    if (!error) {
      throw redirect({
        to: "/dashboard",
      });
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["login/providers"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/auth/providers");

        if (error) {
          // type do error vem como undefined, deveria vir pelo menos com type genérico
          throw new Error(
            (error as any)?.message ||
              "Erro ao carregar servidores de autorização",
          );
        }

        return data;
      },
    });
  },
});
